export default {
  'app.settings.open': 'Open',
  'app.settings.registrationDate': 'Registration date',
  'app.settings.role': 'Role',
  'app.settings.cancelPassword': 'Cancel password',
  'app.settings.bindPassword': 'Bind password',
  'app.settings.changePassword': 'Change password',
  'app.settings.modifyPermissions': 'Modify permissions',
  'app.settings.depositLimit': 'Deposit limit',
  'app.settings.addUser': 'Add user',
  'app.settings.userName': 'username',
  'app.settings.pleaseEnterUsername': 'Please enter username',
  'app.settings.accountNumber614':
    'The account number must be 6-14 characters long and consist of letters and numbers.',
  'app.settings.password': 'Password',
  'app.settings.pleaseEnterPassword': 'Please enter password',
  'app.settings.singleLimit': 'Single limit',
  'app.settings.limitForDay': 'Limit for the day',
  'app.settings.dailyLimitCannot': 'The daily limit cannot be lower than the single limit!',
  'app.settings.selectRole': 'Please select a role',
  'app.settings.sureCancel': 'Are you sure you want to cancel the binding?',
  'app.settings.setAccessLimits': 'Set access limits',
  'app.settings.numberMember': 'Number of deposits per member',
  'app.settings.manualDepositLimit': 'Manual deposit limit',
  'app.settings.enterManualDepositLimit': 'Please enter the single limit for manual deposit',
  'app.settings.enterManualDay': 'Please enter the manual deposit limit for the day',
  'app.settings.enterNumberDeposits': 'Please enter the number of manual deposits',
  'app.settings.preferentialLimit': 'Preferential deposit limit',
  'app.settings.enterPreferentialLimit': 'Please enter the single deposit limit',
  'app.settings.enterDiscountDepositDay': 'Please enter the discount deposit limit for the day',
  'app.settings.enterNumberNumberDeposits': 'Please enter the number of bonus deposits',
  'app.settings.depositLimitWashing': 'Deposit limit for code washing',
  'app.settings.enterDepositLimitWashing':
    'Please enter the single limit of the code washing deposit',
  'app.settings.enterDailyDeposit': 'Please enter the daily limit for deposit',
  'app.settings.enterNumbertheDeposits': 'Please enter the number of deposits',
  'app.settings.otherLimits': 'Other deposit limits',
  'app.settings.enterOtherLimits': 'Please enter other deposit limit',
  'app.settings.enterOtherDay': 'Please enter other deposit limit for the day',
  'app.settings.enterAnotherNumber': 'Please enter another deposit number',
  'app.settings.passwordKey': 'Password key',
  'app.settings.copyKey': 'Copy key',
  'app.settings.hint1': '1. Download Google Dynamic Password on your mobile phone and install it;',
  'app.settings.hint2': '2. In the dynamic password app, click Add Account.',
  'app.settings.hint3':
    '3. Enter the secret key provided above, or select "Scan Barcode" to scan the QR code above.',
  'app.settings.hint4': '4. After adding, click the Bind Password button to complete the binding.',
  'app.settings.characterName': 'Character name',
  'app.settings.permissionSettings': 'Permission settings',
  'app.settings.addNewRole': 'Add new role',
  'app.settings.roleIdentifier': 'Role permission identifier',
  'app.settings.onlJpg/png':
    'Only jpg/png files can be uploaded, and the maximum size is 500kb. The best size is:',
  'app.settings.nodeType': 'Node type',
  'app.settings.currentDirectory': 'Current directory',
  'app.settings.currentMenu': 'Current menu',
  'app.settings.menu': 'menu',
  'app.settings.enterMenuName': 'Please enter a menu name',
  'app.settings.link': 'Link',
  'app.settings.addNodeType': 'Add node type',
  'app.settings.addMenu': 'Add menu',
  'app.settings.addButtonOr': 'Add a button or a third-level menu',
  'app.settings.sureEnable/Disable': 'Are you sure you want to enable/disable?',
  'app.settings.publicIP': 'Public IP',
  'app.settings.ip': 'IP',
  'app.settings.publicIPAddress': 'Public IP address',
  'app.settings.enterIPs':
    'You can enter multiple IP addresses separated by , up to 100 IP addresses',
  'app.settings.pleaseEnterPublicIPAddress': 'Please enter Public IP address',
  'app.settings.enterMaxIPCount': 'You can enter up to 100 IP addresses (currently {count})',
  'app.settings.bankCard/Alipay': 'Bank card/Alipay verification lock time',
  'app.settings.bankCard/Alipaytime': 'Bank card/Alipay verification times',
  'app.settings.customerParameters/account': 'Customer service parameters/account',
  'app.settings.linkAddress': 'Link address',

  'app,H5DownloadApp.Serialumber': 'Serial number',
  'app,H5DownloadApp.Downloadcategory': 'Download category',
  'app,H5DownloadApp.openAndroid': 'Whether to open Android device',
  'app,H5DownloadApp.openiOS': 'Whether to open iOS device',
  'app,H5DownloadApp.downloadAndroid': 'Android download address',
  'app,H5DownloadApp.downloadiOS': 'iOS download address',
  'app,H5DownloadApp.APPname': 'APP display name',
  'app,H5DownloadApp.messageLOGO': 'Push message LOGO image',
  'app,H5DownloadApp.bottom': 'Whether to open the bottom pop-up box',
  'app,H5DownloadApp.top': 'Whether to open the top pop-up box',
  'app,H5DownloadApp.middle': 'Whether to turn on the side hover button',
  'app,H5DownloadApp.APPsettings': 'Download APP settings',
  'app,H5DownloadApp.Downloadpop': 'Download pop-up window settings',
  'app,H5DownloadApp.android': 'Android device',
  'app,H5DownloadApp.ios': 'iOS device ',
  'app,HomeSide.APPDownloadPop': 'APP download pop-up window',
  'app,HomeSide.CustomerServiceCenter': 'Customer service center',
  'app,HomeSide.Discount': 'Discount',
  'app,HomeSide.TopUp': 'Top up',
  'app,HomeSide.WithdrawMoney': 'Withdraw money',
  'app,HomeSide.Invite': 'Invite',
  'app,HomeSide.PersonalCenter': 'Personal center',
  'app,HomeSide.PleaseLink': 'Please select a link',
  'app,HomeSide.HomeSidebar': 'Home Sidebar',
  'app,HomeSide.MainSwitch': 'Main Switch',
  'app,HomeSide.Tips1':
    'Tips: Device codes and IP addresses in the blacklist cannot access the client.',
  'app,HomeSide.Tips2':
    'Warm reminder: The device codes and IP addresses in the whitelist are not subject to registration and login restrictions.',
  'app.settings.tip': 'Tip',
  'app.settings.confirmOperation': 'Confirm the operation?',
  'app.settings.confirmDelete': 'Confirm delete?',
  'app.settings.selectMenu': 'Please select a menu first',
  'app.settings.cannotAddChildren': 'Buttons or third-level menus cannot add sub-nodes',
  'app.settings.addSubNode': 'Add sub-node',
  'app.settings.addCatalog': 'Add catalog',
  'app.settings.filterKeyword': 'Enter keywords to filter',
  'app.settings.catalog': 'Catalog',
  'app.settings.submenu': 'Menu',
  'app.settings.thirdMenu': 'Third-level menu',
  'app.settings.btn': 'Button',
  'app.settings.menuName': 'Menu name',
  'app.settings.enterLink': 'Please enter link address e.g: /xxx/xxx/xx',
  'app.settings.orderNumber': 'Order',
  'app.settings.enterOrderNumber': 'Please enter sort number',
  'app.settings.sortTip': 'The smaller the value, the higher the ranking',
  'app.settings.visible': 'Whether visible',
  'app.settings.permission': 'Permission',
  'app.settings.enterPermission': 'Please enter permission e.g xxx:xxx:xxx',
};
